/**
 * When the interactive Job Locations map should give up and show the
 * schematic Australia outline.
 *
 * Style and tiles returning 200 is not enough to prove the basemap painted:
 * MapLibre can sit idle with an unparsed vector source if the worker never
 * came up, and `queryRenderedFeatures()` then reports nothing. That silent
 * miss used to trip an 8s watchdog and swap in the schematic — the default
 * Leading Edge experience on 3 Sep 2026, despite CloudWatch 200s.
 *
 * Fallback is last-resort only: the style document failed to load, or a
 * tile/style request was rejected with 401 / 403 / 503. An idle map with
 * zero basemap features stays interactive.
 */

export type MapAvailabilitySignal =
  | { readonly kind: 'style-fetch-failed' }
  | { readonly kind: 'http-status'; readonly status: number }
  | { readonly kind: 'idle-without-basemap-features' };

const SCHEMATIC_HTTP_STATUSES = new Set([401, 403, 503]);

export function shouldFallBackToSchematic(signal: MapAvailabilitySignal): boolean {
  switch (signal.kind) {
    case 'style-fetch-failed':
      return true;
    case 'http-status':
      return SCHEMATIC_HTTP_STATUSES.has(signal.status);
    case 'idle-without-basemap-features':
      return false;
  }
}
